var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5286 12.4713C11.7889 12.7317 12.211 12.7317 12.4714 12.4713C12.7317 12.211 12.7317 11.7889 12.4714 11.5285L8.94279 7.99993L12.4714 4.47133C12.7317 4.21098 12.7317 3.78887 12.4714 3.52852C12.211 3.26817 11.7889 3.26817 11.5286 3.52852L7.99999 7.05712L4.47139 3.52851C4.21103 3.26816 3.78893 3.26816 3.52858 3.52851C3.26823 3.78886 3.26823 4.21097 3.52858 4.47133L7.05718 7.99993L3.52857 11.5285C3.26823 11.7889 3.26823 12.211 3.52857 12.4713C3.78893 12.7317 4.21103 12.7317 4.47139 12.4713L7.99999 8.94273L11.5286 12.4713Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9e4aa799c2db227b2e3ab6a4660e0549.svg";
export { ForwardRef as ReactComponent };